export default {
  SetTicketCollection({ commit }, data) {
    commit("ticketCollectionMutation", data);
  },
  // 设置取票游客需登记的信息
  setTouristInfoAction({ commit }, data) {
    commit("setTouristInfo", data);
  }
};
